<button type="button" class="touch-to-speak-toggle"
     [attr.aria-label]="'a11y.open_tts' | translate"
     [class.tts-disabled]="!tooltipEnabled && !compactMode"
     [class.compact]="compactMode"
     (click)="openTtsDrawer()">
  <div class="touch-to-speak-icon" 
      [ngClass]="{active: currentLanguageId != 0}"
        [infoTooltip]="tooltipLabel"
        [tooltipContent]="tooltipContent"
        [tooltipArrowPosition]="'bottom'"
        [arrowXOffset]="null"
        [arrowYOffset]="null"
        [showBackdrop]="false"
        [tooltipArrowOffsetValue]="tooltipArrowOffsetValue"
        [tooltipEnabled]="tooltipEnabled && !compactMode">
          <img class="disabled" src="/assets/touch-to-speak/tts_button.svg" alt="" />
          <img class="active" src="/assets/touch-to-speak/tts_button.svg" alt="" />
  </div>
  <div class="touch-to-speak-chevron" *ngIf="showChevron && !compactMode" [ngClass]="{active: ttsLanguagesDisplayed == true}">
    <img class="up" src="/assets/touch-to-speak/chevron-language{{currentLanguageId > 0 ? '_tts_active' : ''}}.svg" alt="" />
    <img class="down" src="/assets/touch-to-speak/chevron-language{{currentLanguageId > 0 ? '_tts_active' : ''}}.svg" alt="" />
  </div>
</button>

<ion-modal
  [isOpen]="ttsLanguagesDisplayed == true"
  cssClass="tts-language-drawer"
  [backdropDismiss]="true"
  (didDismiss)="onTtsDrawerDismiss()">
  <ng-template>
    <ion-content class="tts-drawer-content" scrollY="false">
      <div class="tts-drawer-header">
        <div class="tts-drawer-icon">
          <img src="/assets/touch-to-speak/tts_button.svg" alt="" />
        </div>
        <div class="tts-drawer-title-group">
          <div class="tts-drawer-title">{{ labels('Choose Language') }}</div>
          <div class="tts-drawer-subtitle">{{ labels('You can have text spoken aloud in your chosen language') }}</div>
        </div>
        <button class="tts-drawer-close" type="button" (click)="closeTtsDrawer()">
          <ion-icon name="close"></ion-icon>
        </button>
      </div>

      <button type="button" class="tts-drawer-selected" [ngClass]="{turnoff: isTurnOffSelected}"
        [attr.aria-label]="'a11y.language' | translate"
        [attr.aria-expanded]="isListOpen"
        aria-controls="tts-drawer-list"
        (click)="toggleList()">
        <div class="tts-drawer-selected-text">
          <div class="tts-drawer-selected-native">{{ selectedTtsLanguageLabel }}</div>
          <div class="tts-drawer-selected-name" *ngIf="selectedTtsLanguageSubLabel">{{ selectedTtsLanguageSubLabel }}</div>
        </div>
        <ion-icon [name]="isListOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
      </button>

      <div class="tts-drawer-list" id="tts-drawer-list" [ngClass]="{open: isListOpen}">
        <button
          class="tts-drawer-item"
          type="button"
          [ngClass]="{active: selectedTtsLanguageId == 0}"
          (click)="selectTurnOff()">
          <div class="tts-drawer-item-native">{{ labels('Turn off') }}</div>
        </button>
        <button
          class="tts-drawer-item"
          type="button"
          *ngFor="let lang of userttslanguages"
          [ngClass]="{active: selectedTtsLanguageId == lang.id}"
          (click)="selectLanguage(lang.id)">
          <div class="tts-drawer-item-native">{{lang.native_name}}</div>
          <div class="tts-drawer-item-name">{{lang.name}}</div>
        </button>
      </div>

      <div class="tts-drawer-callout" *ngIf="hasSelectedLanguage && !isListOpen">
        <div class="tts-drawer-callout-icon">
          <img src="/assets/touch-to-speak/translate_icon_green.svg" alt="" />
        </div>
        <div class="tts-drawer-callout-text">
          <div class="tts-drawer-callout-title">{{ labels('Look out for this icon') }}</div>
          <div class="tts-drawer-callout-body">{{ labels('You can hear the words read aloud when you tap the green speaker icon') }}</div>
        </div>
      </div>

      <ion-button expand="block" class="tts-drawer-save" (click)="saveTtsLanguagePreference()">
        {{ labels('Save preference') }}
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
